import { useExperiment } from '../../common/ExperimentContext/useExperiment';
import { HeNotification } from '../../common/components/HeNotification/HeNotification';
import { useMobile } from '../../common/services/screenSize/ScreenSizeService';
import { CovidSpecialtyMessageExperiment } from './CovidSpecialtyMessageExperiment';

export const CovidSpecialtyMessage = () => {
  const { data } = useExperiment(CovidSpecialtyMessageExperiment);
  const mobile = useMobile();

  if (!data) return null;

  const [title, body] = mobile
    ? [data.mobileTitle, data.mobileBody]
    : [data.desktopTitle, data.desktopBody];

  return (
    <HeNotification hasIcon title={title}>
      {body}
    </HeNotification>
  );
};
